




import {FILTERS_GET_VALUES} from '@/modules/neodash/store/modules/filters/types';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import InSegment from './registration-in-segment.page.vue';
import ByBrand from './registration-by-brand.page.vue';

@Component({
  components: {
    InSegment,
    ByBrand
  }
})
export default class extends Vue {
  @Prop({required: true})
  name: string;

  @Getter(FILTERS_GET_VALUES)
  filtersValues: any;

  public get dataQuery() {
    return {
      ...this.filtersValues,
      name: this.name
    };
  }
}
